import React from 'react';
import App from './App';
import { HashLink as Link } from 'react-router-hash-link';

class Hexagram extends App {
  constructor(props) {
    super(props);

    this.state.content = (
    	<div>
            <div className = "figure-div">
            <figure>
                <img src = {require('./images/polygon/polygon_6_2.png')} alt = 'static'/>
                <figcaption>Regular hexagram {'{'}6/2{'}'}</figcaption>
            </figure>
            </div>

            <div>
    		We can create generic star polygons {'{'}p/q{'}'}, as discussed in <Link to='/heptagram#general'>the previous page</Link>.
            If p and q are not coprime, for example, {'{'}6/2{'}'}, we have degenerate cases.
            </div>
            <br/>
            <div>
            We start from a hexagon and apply faceting or stellation, 
            we end up with the figure above. 
            It has 6 vertices and 6 edges. Remember the intersections of edges don't count as vertices. It is nothing but two overlapping
            equilateral triangles. It is a <a href="https://en.wikipedia.org/wiki/Polytope_compound" target="_blank" rel="noopener noreferrer">compound</a> of multiple polygons 
            rather than one polygon.
            </div>
            <br/>
            <div>
            When we define a polygon or a polytope, 
            we require that all vertices and edges are connected. 
            One should be able to start from
            any vertex, following the edges connecting (incident) to it, 
            and the vertex connecting to that, and so on, to get to any vertex.
            This foundamental criterion excludes the figure of 
            two unconnected triangles as one polygon. 
            This hexagram fails to pass this criterion, 
            and is therefore not a polygon or a polytope.
            </div>
            <br/>
            <div>
            Although the hexagram can be generated by
            same processes that lead to pentagram and heptagrams, 
            and although it's beautiful,
            because it is not a polytope, we will stop discussing it.
            The generalization, regular <a href="https://en.wikipedia.org/wiki/Polytope_compound" target="_blank" rel="noopener noreferrer">polytope compounds</a> are
            all beyond the scope. They could well be another interesting topic
            for another time.
            </div>
    	</div>
    	)
    ;

    this.state.contentHeader = (<span> Hexagram {'{'}6/2{'}'} </span>);
  }
}

export default Hexagram;

